module.exports = __webpack_public_path__ + "static/media/icon_etc.1c81dfb7.svg";